module.exports = __webpack_public_path__ + "static/media/stalkx_clean_grid.141f6a9e.jpg";